import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { CardVariants } from '@user/components/Contacts/ContactCard'
import * as React from 'react'
import { EntityDetailsContactCard } from '@user/features/EntityDetails/components/EntityDetailsContactCard'
import { ENTITY_TYPES, IContact } from '@sales-center/common'
import { LocationOrContact } from '@user/components/Contacts/hooks/useCleanupEntityContacts'
import type { IMoreMenuItem } from '@sales-center/components'
import { useCallback } from 'react'
import { useTheme } from '@mui/material/styles'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  canUpdateEntity: boolean
  primaryContactId: number
  items: LocationOrContact[]
  variant: CardVariants
  primaryContact: IContact
  getMenuItems: (
    item: LocationOrContact,
    variant: CardVariants,
  ) => IMoreMenuItem[] | undefined
}

export function EntityDetailsContactList(props: Props) {
  const { items, primaryContactId, primaryContact, getMenuItems, variant } =
    props

  const hideContactsList = !items || !items.length

  const locationType = useCallback(
    (item) =>
      item.type === 'location'
        ? item.isBillToAndService
          ? 'both'
          : item.data.billingLocation
          ? 'billto'
          : 'service'
        : undefined,
    [],
  )
  const theme = useTheme()
  return (
    <Box>
      {hideContactsList ? (
        <Box p={2}>
          <Typography color={theme.palette.text.primary} fontSize="16px">
            No additional contacts added
          </Typography>
        </Box>
      ) : (
        <Box color={theme.palette.text.primary} fontSize="16px">
          {items.map((item, index) => {
            const primaryContactData: IContact | null =
              primaryContact.id == item.data.contact.id ? primaryContact : null
            return (
              <Box p={2} key={`contact_card_${index}`}>
                <EntityDetailsContactCard
                  {...props}
                  key={item.data.contact.id}
                  contact={item.data.contact}
                  isPrimaryContact={item.data.contact.id === primaryContactId}
                  primaryContactData={primaryContactData}
                  maxWidth="1000px"
                  locationType={locationType(item)}
                  menuOptions={getMenuItems(item, variant)}
                />
              </Box>
            )
          })}
        </Box>
      )}
    </Box>
  )
}
